import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import Login from './views/Login/Login';
import External from './views/External/External';
import RegistrationSuccess from './views/External/RegistrationSuccess';
import Dashboard from './components/dashboard/Dashboard';
import Settings from './views/Settings/Settings';
import Sidebar from './components/sidebar/Sidebar';
import PrivateRoute from './components/auth/PrivateRoute';
import AuthProvider from './components/auth/AuthProvider';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/scss/main.scss';

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/external" element={<External />} />
          <Route path="/external/success" element={<RegistrationSuccess />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <>
                  <Sidebar />
                  <div className="main-content">
                    <Dashboard />
                  </div>
                </>
              </PrivateRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <>
                  <Sidebar />
                  <div className="main-content">
                    <Settings />
                  </div>
                </>
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

const Root = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

export default Root; 